'use client';

import type { ChannelMessageReport } from '../../functions/reports/subscribeToChannelReports';
import type { CommunityChannel } from '../../types/CommunityChannel';
import { ChannelMessageBubble } from '../channel-message-view/ChannelMessageBubble';

interface Props {
  channel: CommunityChannel;
  report: ChannelMessageReport;
  currentUserId: string | null | undefined;
}

/**
 * One row in the Reports panel — the reason tag above the reported message
 * bubble (rendered inline so replies expand in place). The message snapshot is
 * embedded on the report doc, so unlike {@link BookmarkedMessageRow} there's no
 * lazy fetch; a missing snapshot falls back to a compact "no longer available"
 * line.
 */
export function ReportedMessageRow({ channel, report, currentUserId }: Props) {
  if (!report.message) {
    return (
      <div className="text-content-3 text-xs">
        Reported message no longer available — reason {report.reason}.
      </div>
    );
  }
  return (
    <>
      <div className="bg-danger/10 mb-1 inline-flex items-center gap-2 rounded-full px-2 py-0.5 text-[11px] text-red-300">
        Reason: {report.reason}
      </div>
      <ChannelMessageBubble
        message={report.message}
        currentUserId={currentUserId}
        channelSlug={channel.slug}
        repliesMode="inline"
      />
    </>
  );
}
